import requestStatus from "../../../constants/requestStatus"
import OverlaySpinner from "../../overlay/presentational/OverlaySpinner"
import OverlayText from "../../overlay/presentational/OverlayText"

const PageEventsPageOverlay = ({eventsStatus, eventsError, settingsStatus, settingsError, displayOverlay, setDisplayOverlay}) => {
    if(requestStatus.REQUEST_PENDING === eventsStatus || requestStatus.REQUEST_PENDING === settingsStatus) {
        return <OverlaySpinner
            transId="data_is_loading"
        />
    } else if(displayOverlay && requestStatus.REQUEST_ERROR === eventsStatus) {
        return <OverlayText
            titleTransId="an_error_has_occurred"
            text={eventsError ? eventsError.events : ''}
            buttonTextTransId='button_close'
            onClickButton={() => setDisplayOverlay(false)}
        />
    } else if(displayOverlay && requestStatus.REQUEST_ERROR === settingsStatus) {
        return <OverlayText
            titleTransId="an_error_has_occurred"
            text={settingsError ? settingsError.settings : ''}
            buttonTextTransId='button_close'
            onClickButton={() => setDisplayOverlay(false)}
        />
    } else {
        return ''
    }
}

export default PageEventsPageOverlay